var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_235_1235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_235_1235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_235_1235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0041 12.3953C14.4031 12.3953 15.5337 12.8385 17.2708 14.5835L26.5913 23.946C26.8669 24.2231 26.9221 24.3337 26.9772 24.4999C27.0048 24.5553 27.0048 24.6385 27.0048 24.6939C27.0048 24.7493 27.0048 24.8324 26.9772 24.8878C26.9221 25.054 26.8669 25.1648 26.5913 25.4418L20.2214 31.8681C19.9457 32.1451 19.8353 32.2005 19.6699 32.2559C19.6148 32.2835 19.532 32.2835 19.4769 32.2835C19.4218 32.2835 19.339 32.2835 19.2839 32.2559C19.1185 32.2005 19.0081 32.1451 18.7324 31.8681L0.670753 13.7249C0.146938 13.1986 0.339966 12.3953 1.22234 12.3953H12.0041ZM38.3105 0.955368C35.9116 0.955368 34.7809 1.3986 33.0438 3.14374L23.7234 12.5061C23.4477 12.7831 23.3926 12.8939 23.3373 13.0601C23.3098 13.1155 23.3098 13.1986 23.3098 13.254C23.3098 13.3094 23.3098 13.3926 23.3373 13.448C23.3926 13.614 23.4477 13.725 23.7234 14.002L30.0933 20.4005C30.3689 20.6775 30.4793 20.7329 30.6447 20.7883C30.6999 20.816 30.7826 20.816 30.8377 20.816C30.8929 20.816 30.9756 20.816 31.0308 20.7883C31.1962 20.7329 31.3066 20.6775 31.5822 20.4005L49.6439 2.25728C50.1677 1.73102 49.9747 0.927734 49.0923 0.927734H38.3105V0.955368Z",
    fill: "#08CF65"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_235_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.55,
    height: 31.4457,
    fill: "white",
    transform: "translate(0.382324 0.927734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_235_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.55,
    height: 31.4457,
    fill: "white",
    transform: "translate(0.382324 0.927734)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_235_1235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.55,
    height: 31.4452,
    fill: "white",
    transform: "translate(0.382324 0.927734)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo9);
export default __webpack_public_path__ + "static/media/logo9.9445361550c0926f7c8fd0bc368e19ec.svg";
export { ForwardRef as ReactComponent };